<ca-one-search-input> </ca-one-search-input>

<ca-one-search-results *ngIf="showResults$ | async"></ca-one-search-results>
